module.exports = __webpack_public_path__ + "static/media/Sub-1-Building-Use-Restrictions-Westbriar-Village.a8111183.pdf";